<ng-container *transloco="let t">
  @if (searchResults?.length) {
    <div
      class="grid-container"
      [class.mobile]="(biggerThan$ | async)?.mobileL"
      [class.widescreen]="(biggerThan$ | async)?.sm">
      @for (product of searchResults; track trackByProduct($index, product)) {
        <app-product-card
          class="grid-item"
          inViewport
          [product]="product"
          [inViewportOptions]="{ threshold: [0] }"
          (inViewportAction)="onIntersection($event)"></app-product-card>
      }
      @if (loading) {
        @for (item of [null, null, null]; track trackByProduct($index, item)) {
          <app-product-card
            class="grid-item"
            inViewport
            [product]="item"
            [inViewportOptions]="{ threshold: [0] }"
            (inViewportAction)="onIntersection($event)"></app-product-card>
        }
      }
      <!-- ICONS -->
      @if (searchResults && !loading) {
        @if (searchResults && (searchResults?.length || 0) > 3) {
          <div class="icon-item first-icon popsy-card">
            <popsy-icon-return-dark
              class="icon fill-secondary-light"></popsy-icon-return-dark>
            <span class="fixed-space-16" aria-hidden="true"></span>
            <span class="label"> {{ t('about_return_title') }} </span>
          </div>
        }
        @if (searchResults && (searchResults?.length || 0) > 9) {
          <div class="icon-item second-icon popsy-card">
            <popsy-icon-installments-dark
              class="icon fill-secondary-light"></popsy-icon-installments-dark>
            <span class="fixed-space-16" aria-hidden="true"></span>
            <span class="label">{{ t('label_installment_plan') }}</span>
          </div>
        }
        @if (
          searchResults &&
          !(biggerThan$ | async)?.mobileL &&
          (searchResults?.length || 0) > 14
        ) {
          <div class="icon-item third-icon popsy-card">
            <popsy-icon-warranty-dark
              class="icon fill-secondary-light"></popsy-icon-warranty-dark>
            <span class="fixed-space-16" aria-hidden="true"></span>
            <span class="label">
              {{ t('title_featured_warranty_variable', { var1: months }) }}</span
            >
          </div>
        }
      }
      <span class="fixed-space-64" aria-hidden="true"></span>
    </div>
  }

  <!-- EMPTY SEARCH RESULTS -->
  @if (!searchResults?.length && !loading && (searchParams$ | async); as params) {
    <section
      [class.mobile]="(biggerThan$ | async)?.mobileL"
      [class.widescreen]="(biggerThan$ | async)?.sm"
      class="mock">
      <h2>{{ t('empty_state_subtitle') }}</h2>
      <span class="fixed-space-8" aria-hidden="true"></span>
      <div class="flex flex-col">
        <div class="flex flex-col">
          <popsy-icon-no-search class="img"></popsy-icon-no-search>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <h3>{{ t('hint_search_on_popsy') }}</h3>
        </div>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div class="flex flex-row align-base">
          @if (params) {
            <div class="flex flex-row">
              @for (
                param of searchParamsFiltered | keyvalue;
                track trackByModel($index, param)
              ) {
                <span class="popsy-card italic">{{ param.key }}: {{ param.value }} </span>
                <span class="fixed-space-4" aria-hidden="true"></span>
              }
            </div>
          }
          <span class="fixed-space-8" aria-hidden="true"></span>
          <div (click)="onClearFilters()" class="clear">
            {{ t('tooltip_clear_filters') }}
          </div>
        </div>
        <span class="fixed-space-8" aria-hidden="true"></span>
      </div>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <section class="products-content">
        <div class="grid four-col">
          <div class="info">
            <span class="bold">iPhones</span>
            @for (
              product of iPhones$ | async | slice: 0 : 7;
              track trackByModel($index, product)
            ) {
              <span
                [routerLink]="productFragment(product.id)"
                [queryParams]="params"
                (click)="scrollTop()"
                >{{ product.model }}</span
              >
            }
          </div>
          <div class="info">
            <span class="bold">{{ t('category_laptop_title') }}</span>
            @for (
              product of laptops$ | async | slice: 0 : 7;
              track trackByModel($index, product)
            ) {
              <span
                [routerLink]="productFragment(product.id)"
                [queryParams]="params"
                (click)="scrollTop()"
                >{{ product.model }}</span
              >
            }
          </div>
          <div class="info">
            <span class="bold">{{ t('category_tablet_title') }}</span>
            @for (
              product of tablets$ | async | slice: 0 : 7;
              track trackByModel($index, product)
            ) {
              <span
                [routerLink]="productFragment(product.id)"
                [queryParams]="params"
                (click)="scrollTop()"
                >{{ product.model }}</span
              >
            }
          </div>
          <div class="info">
            <span class="bold">{{ t('category_watch_title') }}</span>
            @for (
              product of watches$ | async | slice: 0 : 4;
              track trackByModel($index, product)
            ) {
              <span
                [routerLink]="productFragment(product.id)"
                [queryParams]="params"
                (click)="scrollTop()"
                >{{ product.model }}</span
              >
            }
          </div>
        </div>
      </section>
    </section>
  }
</ng-container>
